export const MIN_MAX_OUTPUT = {
    DEFAULT_PULSE: { start: 0, end: 120 }
}

export const OUTPUT_NUMBER_DATA = {
    OUTPUT_1: {
        id: 0,
        name: 'OUTPUT 1'
    },
    OUTPUT_2: {
        id: 1,
        name: 'OUTPUT 2'
    },
    OUTPUT_3: {
        id: 2,
        name: 'OUTPUT 3'
    },
    OUTPUT_4: {
        id: 3,
        name: 'OUTPUT 4'
    }
}
export const OUTPUT_DATA = {
    name: null,
    controllerId: null,
    hidSioId: null,
    number: "",
    defaultPulse: null,
    toAddEdit: function () {
        return {
            name: this.name,
            hidSioId: this.hidSioId,
            number: this.number,
            defaultPulse: this.defaultPulse
        }
    },
    isValid: function () {
        return this.name !== null && this.name !== '' && this.hidSioId !== null && this.number !== ""
            && this.defaultPulse !== null && this.defaultPulse !== "";
    },
    setToTable: function (data, sioName) {
        return {
            id:data.id,
            hidSioId: data.hidSioId,
            hidSioName: sioName,
            name: data.name,
            number: data.number,
            defaultPulse: data.defaultPulse,
            deviceType: data.deviceType,
            sioType: data.sioType
        }
    },
}
